import React from 'react';
import { Button, List, useTheme } from '@mui/material';
import { MessageDialogProps } from './types';
import DialogChoice from '10.quickConnect.app/components/shared/Dialogs/DialogChoice';

// Popup d'une saisie : un titre, un message, les choix proposés et, le cas échéant, un bouton de fermeture
const MessageDialog = ({ name, open, onClose, title, message = [], options, closeLabel }: MessageDialogProps) => {
  const theme = useTheme();
  const paragraphs = Array.isArray(message) ? message : [message];

  return (
    <DialogChoice name={name} onClose={onClose} open={open}>
      <DialogChoice.Title name={name}>{title}</DialogChoice.Title>
      <DialogChoice.Content name={name}>
        {paragraphs.map((paragraph: string) => (
          <DialogChoice.ContentText key={paragraph} name={name}>
            {paragraph}
          </DialogChoice.ContentText>
        ))}
        <List>
          {options.map(({ name: optionName, label, icon, onClick }) => (
            <DialogChoice.Option
              key={optionName}
              handleClick={onClick}
              name={`${name}-${optionName}`}
              optionTitle={label}
              avatar={icon}
              sx={{ backgroundColor: theme.palette.primary.main }}
            />
          ))}
        </List>
      </DialogChoice.Content>
      {closeLabel && (
        <DialogChoice.Actions name={name}>
          <Button data-cy={`${name}-close`} onClick={onClose} variant="contained">
            {closeLabel}
          </Button>
        </DialogChoice.Actions>
      )}
    </DialogChoice>
  );
};

export default MessageDialog;
